// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+1+Code:wght@100..700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sen:wght@400;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: inherit;
  margin: 0;
  font-family: "Outfit", sans-serif;
  font-size: 18px;
  box-sizing: border-box;
  letter-spacing: 0.02em;
  font-weight: 400;
  line-height: 1.3;
}

body {
  font-weight: 400;
  color: #513C6A;
  background-color: #FFFFFF;
}

a {
  text-decoration: none;
}

svg {
  width: 32px;
  height: 32px;
  stroke-width: 1.5px;
}

.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  color: #261147;
  padding: 24px;
  font-size: 32px;
  text-align: center;
}

.page-title {
  font-size: clamp(24px, 4vw, 32px);
  color: #FF6A56;
}

.main_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 80%;
  max-width: 560px;
  padding: 16px 32px 32px;
  margin: 12px 0;
  background-color: #F5F6FA;
  border-radius: 16px;
}
.main_box .ds_title {
  font-size: 27px;
  color: #FF6A56;
}

.button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  border-radius: 10px;
  color: #FFFFFF;
  border: solid 2px #261147;
  cursor: pointer;
  position: relative;
  background-color: #261147;
  width: 100%;
  height: 52px;
  padding: 0 8px 0 8px;
  transition: all 0.2s ease;
  box-sizing: border-box;
  line-height: 100%;
}
.button .svg-icon {
  width: 26px;
  height: auto;
  min-width: 26px;
  transition: fill 0.3s ease;
}
.button:hover {
  background-color: #FF6A56;
  border: solid 2px #FF6A56;
  color: #FFFFFF;
  transition: all 0.2s ease;
}
.button:hover .svg-icon {
  color: #FFFFFF;
}
@media screen and (max-width: 768px) {
  .button {
    height: 54px;
  }
}

.small {
  height: 38px;
  padding: 0 12px;
  justify-content: center;
  text-align: center;
}
.small:hover {
  background-color: rgba(38, 17, 71, 0.7);
  color: #FFFFFF;
  border: solid 2px rgba(38, 17, 71, 0);
  transition: all 0.2s ease;
}
@media screen and (max-width: 768px) {
  .small {
    padding: 0 8px;
    font-size: 16px;
  }
}

.lined {
  color: #261147;
  background-color: transparent;
  border: solid 2px #261147;
  color: #261147;
}

.sec {
  color: #261147;
  background-color: transparent;
  border: solid 2px #FF6A56;
  color: #FF6A56;
}

.nav-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
  border: none;
  height: auto;
  width: fit-content;
  background-color: transparent;
  border: solid 2px transparent;
  color: #261147;
  padding: 4px;
}
.nav-btn .svg-icon {
  width: 36px;
  height: 36px;
  stroke-width: 1.3px;
  border: solid 2px transparent;
}
.nav-btn:hover {
  color: #FF6A56;
  background-color: #F0F0F9;
  border: 2px solid transparent;
}
.nav-btn:hover .svg-icon {
  color: #FF6A56;
  border: solid 2px transparent;
}

.validation-message {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.validation-message .spinner, .validation-message .check, .validation-message .cross {
  font-size: 16px;
  min-width: 16px;
}
.validation-message.checking {
  color: #BBBDD6;
  background-color: #F5F6FA;
  border: 1px solid #F0F0F9;
}
.validation-message.checking .spinner {
  animation: spin 1s linear infinite;
}
.validation-message.success {
  color: #22c55e;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
}
.validation-message.success .check {
  color: #22c55e;
}
.validation-message.error {
  color: #ef4444;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
}
.validation-message.error .cross {
  color: #ef4444;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.input-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}

.input-icon-box {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 2px solid #DEDEEB;
  border-radius: 12px;
  padding: 0 12px;
  height: 52px;
  transition: all 0.3s;
  background-color: #FFFFFF;
  width: 100%;
  box-sizing: border-box;
}
.input-icon-box.focused {
  border-color: #15A6F8;
}
.input-icon-box.focused .icon {
  color: #15A6F8;
}
.input-icon-box.error {
  border-color: #D90D3E;
}
.input-icon-box.error .icon {
  color: #D90D3E;
}
.input-icon-box .icon {
  display: flex;
  align-items: center;
  color: #ABADC8;
}
.input-icon-box .icon svg {
  width: 24px;
  height: 24px;
}
.input-icon-box .input-wrapper {
  display: flex;
  flex: 1 1;
  align-items: center;
}
.input-icon-box .input-prefix {
  color: #15A6F8;
}
.input-icon-box .input {
  flex: 1 1;
  border: none;
  outline: none;
  background-color: transparent;
  color: #261147;
  width: 100%;
}
.input-icon-box .input.no-match {
  color: #D90D3E;
}
.input-icon-box .input::placeholder {
  color: #ABADC8;
  transition: all 0.3s;
}
.input-icon-box .input:focus::placeholder {
  color: #CCCEDE;
}
@media screen and (max-width: 768px) {
  .input-icon-box {
    height: 56px;
  }
}

.char-counter {
  color: #BBBDD6;
}

.with-label {
  flex-direction: column;
  align-items: start;
}
.with-label .input-label {
  color: #261147;
  text-align: left;
  padding: 0 16px;
  text-wrap: nowrap;
}

.compact-field-hero {
  position: relative;
  width: 100%;
}
.compact-field-hero .compact-button {
  position: absolute;
  right: 2px;
  top: 0;
  z-index: 1;
  height: calc(100% - 4px);
}
.compact-field-hero .compact-button .button {
  margin: 2px 0;
  border-radius: 0 10px 10px 0;
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .compact-field-hero {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: static;
    width: 100%;
  }
  .compact-field-hero .compact-button {
    position: static;
  }
  .compact-field-hero .compact-button .button {
    margin: 0;
    border-radius: 10px;
    height: 54px;
  }
}
.compact-field-hero.status-neutral .compact-button .button {
  background-color: #261147;
  border-color: #261147;
  color: #FFFFFF;
  transition: all 0.2s ease;
}
.compact-field-hero.status-neutral .compact-button .button:hover {
  background-color: #FF6A56;
  border-color: #FF6A56;
}
.compact-field-hero.status-neutral .compact-button .button.disabled {
  background-color: #CCCEDE;
  border-color: #CCCEDE;
  opacity: 0.6;
}
.compact-field-hero.status-checking .compact-button .button {
  background-color: #15A6F8;
  border-color: #15A6F8;
  color: #FFFFFF;
  transition: all 0.2s ease;
}
.compact-field-hero.status-checking .compact-button .button .svg-icon {
  color: #FFFFFF;
}
.compact-field-hero.status-checking .compact-button .button:hover {
  background-color: rgb(45.7593360996, 175.4170124481, 248.7406639004);
  border-color: rgb(45.7593360996, 175.4170124481, 248.7406639004);
}
.compact-field-hero.status-success .compact-button .button {
  background-color: #00DEA3;
  border-color: #00DEA3;
  color: #FFFFFF;
  transition: all 0.2s ease;
}
.compact-field-hero.status-success .compact-button .button .svg-icon {
  color: #FFFFFF;
}
.compact-field-hero.status-success .compact-button .button:hover {
  background-color: rgb(0, 247.5, 181.722972973);
  border-color: rgb(0, 247.5, 181.722972973);
}
.compact-field-hero.status-error .compact-button .button {
  background-color: #D90D3E;
  border-color: #D90D3E;
  color: #FFFFFF;
  transition: all 0.2s ease;
}
.compact-field-hero.status-error .compact-button .button .svg-icon {
  color: #FFFFFF;
}
.compact-field-hero.status-error .compact-button .button:hover {
  background-color: rgb(240.6152173913, 14.8847826087, 69.1043478261);
  border-color: rgb(240.6152173913, 14.8847826087, 69.1043478261);
}
.compact-field-hero.status-error .compact-button .button.disabled {
  opacity: 0.7;
}
.compact-field-hero.status-error .compact-button .button.disabled:hover {
  background-color: #D90D3E;
  border-color: #D90D3E;
}

.big-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: auto;
  height: auto;
  font-size: 26px;
  font-weight: 500;
  color: #FF6A56;
}
.big-title svg {
  width: 32px;
}

.input-icon-box {
  position: relative;
}
.input-icon-box .dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #FFFFFF;
  border: 2px solid #15A6F8;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 4px;
  padding: 8px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  text-align: left;
}
.input-icon-box .dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 17px;
  color: #261147;
  display: flex;
  transition: all 0.3s ease;
}
.input-icon-box .dropdown-option:hover {
  background-color: #F5F6FA;
  color: #261147;
}
.input-icon-box .selected-option {
  background-color: #F5F6FA;
  color: #261147;
}
.input-icon-box .right-icon {
  cursor: pointer;
}

.search-bar .search-bar-meta {
  font-size: 16px;
  color: #FF6A56;
  padding: 0 2px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.checkbox-icon-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.checkbox-icon-box:hover {
  color: #FF6A56;
}
.checkbox-icon-box .custom-checkbox {
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #DEDEEB;
  color: #DEDEEB;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  padding: 4px;
  background-color: #FFFFFF;
}
.checkbox-icon-box .custom-checkbox svg {
  width: 100%;
  stroke-width: 3px;
}
.checkbox-icon-box .custom-checkbox.checked {
  background-color: #FF6A56;
  border-color: #FF6A56;
  color: #FFFFFF;
}
@media screen and (max-width: 768px) {
  .checkbox-icon-box .custom-checkbox {
    width: 32px;
    height: 32px;
  }
}
.checkbox-icon-box .checkbox-input {
  cursor: pointer;
}

.toggle-switch {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  gap: 12px;
}
.toggle-switch.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.toggle-switch .switch-track {
  position: relative;
  --W-size: 54px;
  width: var(--W-size);
  min-width: var(--W-size);
  --h-size: 30px;
  height: var(--h-size);
  min-height: var(--h-size);
  background-color: #DEDEEB;
  border-radius: 50px;
  transition: all 0.2s ease;
}
.toggle-switch .switch-track.checked {
  background-color: #FF6A56;
  border-color: #FF6A56;
}
.toggle-switch .switch-track .switch-thumb {
  position: absolute;
  width: 24px;
  height: 24px;
  left: 3px;
  top: 3px;
  background-color: #FFFFFF;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toggle-switch .switch-track .switch-thumb svg {
  width: 20px;
  height: 20px;
  color: #DEDEEB;
  display: none;
}
.toggle-switch .switch-track .switch-thumb.checked {
  transform: translateX(24px);
}
.toggle-switch .switch-track .switch-thumb.checked svg {
  color: #FF6A56;
}
.toggle-switch .switch-label {
  font-size: 17px;
  color: #261147;
  font-weight: 400;
}
.toggle-switch:hover:not(.disabled) .switch-track {
  background-color: #CCCEDE;
  border-color: #CCCEDE;
  transition: all 0.2s ease;
}
.toggle-switch:hover:not(.disabled) .switch-track.checked {
  background-color: rgb(239, 28.2840236686, 0);
  border-color: rgb(239, 28.2840236686, 0);
}
@media screen and (max-width: 768px) {
  .toggle-switch .switch-track {
    --W-size: 54px;
    width: var(--W-size);
    min-width: var(--W-size);
    --h-size: 32px;
    height: var(--h-size);
    min-height: var(--h-size);
  }
  .toggle-switch .switch-track .switch-thumb {
    width: 24px;
    height: 24px;
    left: 3px;
    top: 4px;
  }
}

.tag-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
}
.tag-container .tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 4px;
  width: auto;
  height: 40px;
  border: 2px solid #FF6A56;
  color: #FF6A56;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.tag-container .tag.selected {
  background-color: #FF6A56;
  color: #FFFFFF;
}
.tag-container .tag svg {
  height: 24px;
  width: 24px;
}
@media screen and (max-width: 768px) {
  .tag-container .tag {
    height: 48px;
  }
}

.tab-container {
  display: flex;
  flex-direction: row;
  height: 44px;
  flex-wrap: nowrap;
  overflow-x: auto;
  border-radius: 8px;
  border: 2px solid #FF6A56;
}
.tab-container .tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  width: auto;
  color: #FF6A56;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.tab-container .tab.selected {
  background-color: #FF6A56;
  color: #FFFFFF;
}
.tab-container .tab:hover {
  background-color: #FF6A56;
  color: #FFFFFF;
}
.tab-container .tab svg {
  height: 24px;
  width: 24px;
}
@media screen and (max-width: 768px) {
  .tab-container {
    height: 50px;
  }
}

.textarea-icon-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}
.textarea-icon-box .input-top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
}
.textarea-icon-box .input-top-box .left-side {
  display: flex;
  align-items: center;
  gap: 4px;
}
.textarea-icon-box .input-top-box .left-side svg {
  width: 28px;
  height: 28px;
  color: #BBBDD6;
}
.textarea-icon-box .input-top-box .left-side .textarea-title {
  color: #ABADC8;
  transition: color 0.3s;
}
.textarea-icon-box .input-top-box .left-side .focused {
  color: #15A6F8;
}
.textarea-icon-box .input-top-box .left-side .focused svg {
  color: #15A6F8;
}
.textarea-icon-box .input-top-box .char-counter {
  font-size: 17px;
}
.textarea-icon-box .input-top-box .char-counter.red {
  color: #D90D3E;
}
.textarea-icon-box .input {
  width: 100%;
  height: 188px;
  border: 2px solid #DEDEEB;
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}
.textarea-icon-box .input::placeholder {
  color: #BBBDD6;
  font-style: italic;
}
.textarea-icon-box .input:focus {
  border-color: #15A6F8;
  outline: none;
}
.textarea-icon-box .input:focus ~ .input-top-box .textarea-title, .textarea-icon-box .input:focus ~ .input-top-box .left-icon {
  color: #15A6F8;
}

.compact-textarea {
  position: relative;
}
.compact-textarea .input-top-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 52px;
  background-color: #FFFFFF;
  margin: 4px;
  padding: 0 12px 0 8px;
  display: flex;
  align-items: center;
}
.compact-textarea .input {
  padding-top: 54px;
}

.input-icon-box {
  position: relative;
  width: 100%;
}
.input-icon-box .input-container {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  transition: border-color 0.3s;
}
.input-icon-box .input-container svg {
  width: 28px;
  height: 28px;
  color: #BBBDD6;
}
.input-icon-box .input-container.focused {
  border-color: #FF6A56;
}
.input-icon-box .input-container .input {
  border: none;
  outline: none;
  flex: 1 1;
  padding: 5px;
  color: #261147;
}
.input-icon-box .input-container .input.no-match {
  color: #D90D3E;
}
.input-icon-box .input-container .input::placeholder {
  color: #BBBDD6;
}
.input-icon-box .dropdown {
  position: absolute;
  top: 104%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #FFFFFF;
  border: 2px solid #15A6F8;
  border-radius: 16px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.input-icon-box .dropdown .dropdown-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  cursor: pointer;
  color: #261147;
}
.input-icon-box .dropdown .dropdown-option.selected {
  background-color: #F5F6FA;
}
.input-icon-box .dropdown .dropdown-option svg {
  width: 28px;
  height: 28px;
  border-radius: 24px;
}
.input-icon-box .dropdown .dropdown-option:hover {
  background-color: #F0F0F9;
}
.input-icon-box .dropdown .dropdown-option.highlighted {
  background-color: #F0F0F9;
  color: white;
}
.input-icon-box .flag-icon-in-input {
  width: 28px;
  height: 28px;
  border-radius: 20px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(38, 17, 71, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-overlay .popup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 32px 40px;
  width: 90%;
  max-width: 460px;
  position: relative;
}
@media screen and (max-width: 460px) {
  .popup-overlay .popup-container {
    padding: 24px;
  }
  .popup-overlay .popup-container .popup-illus {
    width: 100px;
    stroke-width: 2.8px;
  }
}
.popup-overlay .popup-container .mailto-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 460px;
  height: 54px;
  border-radius: 8px;
  padding: 0 24px !important;
  background-color: transparent;
  border: 2px solid #FF6A56;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #FF6A56;
}
.popup-overlay .popup-container .mailto-btn:hover {
  background-color: #FF6A56;
  transition: all 0.2s ease;
  color: #FFFFFF;
}
.popup-overlay .popup-container span {
  font-size: 16px;
  color: #878BBA;
}

.popup-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.popup-illus {
  width: 120px;
  height: auto;
  stroke-width: 2.4px;
  color: #FF6A56;
}

.popup-title {
  font-size: 26px;
  color: #FF6A56;
  flex: 1 1;
  line-height: 1.1;
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  color: #CCCEDE;
}
.popup-close svg {
  width: 100%;
  height: 100%;
  transition: color 0.2s ease;
}
.popup-close:hover {
  color: #FF6A56;
  scale: 1.1;
}

.popup-text {
  text-align: center;
}

.popup-children-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
}
.popup-children-box p strong {
  color: #FF6A56;
}

.signup-verification-popup .verification-popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}
.signup-verification-popup .verification-message {
  font-size: 16px;
  line-height: 1.5;
  color: #878BBA;
  text-align: center;
  margin: 0;
}
.signup-verification-popup .verification-message strong {
  color: #FF6A56;
  font-weight: 600;
}
.signup-verification-popup .countdown-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 16px 16px 24px;
  background-color: #F5F6FA;
  border-radius: 12px;
  width: 100%;
}
.signup-verification-popup .countdown-timer {
  font-size: 32px;
  color: #FF6A56;
  letter-spacing: 2px;
}
.signup-verification-popup .countdown-text {
  font-size: 16px;
  color: #878BBA;
  text-align: center;
  margin: 0;
}

.photo-uploader-circle {
  border-radius: 50%;
  background-color: #F5F6FA;
  border: 2px dashed #DEDEEB;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
}
.photo-uploader-circle::before {
  content: "";
  position: absolute;
  left: -100px;
  top: 50%;
  transform: translateY(-50%);
  height: 8px;
  width: 80px;
  background-color: #ebebf9;
  border-radius: 0px;
  z-index: -1;
}
.photo-uploader-circle.drag-active {
  border-color: #15A6F8;
  box-shadow: 0 0 0 4px rgba(21, 166, 248, 0.2);
}
.photo-uploader-circle.has-image {
  border-color: #ebebf9;
}
.photo-uploader-circle .photo-placeholder-circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #BBBDD6;
  position: relative;
}
.photo-uploader-circle .photo-placeholder-circle svg {
  width: 44px;
  height: 44px;
  stroke-width: 1px;
  color: #BBBDD6;
  transition: all 0.2s ease;
}
.photo-uploader-circle .photo-placeholder-circle .upload-text {
  font-size: 12px;
  color: #ABADC8;
  margin-top: 8px;
}
.photo-uploader-circle .uploaded-image-circle {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-uploader-circle:hover {
  background-color: rgba(38, 17, 71, 0.3);
}
.photo-uploader-circle:hover .upload-text {
  color: #FFFFFF;
}
.photo-uploader-circle:hover svg {
  stroke-width: 1.2px;
  color: #FFFFFF;
  scale: 1.1;
  transition: all 0.2s ease;
}
.photo-uploader-circle .image-overlay-circle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  gap: 8px;
  background-color: rgba(38, 17, 71, 0.4);
}
.photo-uploader-circle .image-overlay-circle .delete-photo-btn, .photo-uploader-circle .image-overlay-circle .change-photo-btn {
  background-color: rgba(38, 17, 71, 0.7);
  color: #FFFFFF;
  border: none;
  border-radius: 44px;
  --avatar-size: 40px;
  width: var(--avatar-size);
  height: var(--avatar-size);
  min-width: var(--avatar-size);
  min-height: var(--avatar-size);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.photo-uploader-circle .image-overlay-circle .delete-photo-btn svg, .photo-uploader-circle .image-overlay-circle .change-photo-btn svg {
  --avatar-size: 24px;
  width: var(--avatar-size);
  height: var(--avatar-size);
  min-width: var(--avatar-size);
  min-height: var(--avatar-size);
  stroke-width: 1.2px;
}
.photo-uploader-circle .image-overlay-circle .delete-photo-btn:hover, .photo-uploader-circle .image-overlay-circle .change-photo-btn:hover {
  background-color: #D90D3E;
  transform: scale(1.1);
}
.photo-uploader-circle .image-overlay-circle .delete-photo-btn {
  background-color: #D90D3E;
}
.photo-uploader-circle .image-overlay-circle .change-photo-btn {
  background-color: #00DEA3;
}
.photo-uploader-circle .image-overlay-circle .change-photo-btn:hover {
  background-color: #00DEA3;
  transform: scale(1.1);
}
.photo-uploader-circle:hover .image-overlay-circle {
  opacity: 1;
}

.cropper-area {
  position: relative;
  width: 280px;
  height: 280px;
  border-radius: 300px;
  overflow: hidden;
  background-color: #F5F6FA;
  transition: all 0.2s ease;
}
.cropper-area .reactEasyCrop_Container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
@media screen and (max-width: 460px) {
  .cropper-area {
    width: 200px;
    height: 200px;
    transition: all 0.2s ease;
  }
}

.cropper-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.cropper-controls .zoom-control {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cropper-controls .zoom-control span {
  color: #ABADC8;
  font-size: 14px;
  min-width: 40px;
}
.cropper-controls .zoom-control input[type=range] {
  flex: 1 1;
  height: 8px;
  appearance: none;
  background: linear-gradient(to right, #ebebf9 0%, #ebebf9 100%);
  border-radius: 12px;
  outline: none;
  position: relative;
}
.cropper-controls .zoom-control input[type=range]:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #F5F6FA;
  border-radius: 12px;
  z-index: -1;
}
.cropper-controls .zoom-control input[type=range] {
  /* Webkit (Chrome, Safari, Edge) */
}
.cropper-controls .zoom-control input[type=range]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #FF6A56;
  border: 2px solid #FF6A56;
  cursor: pointer;
}
.cropper-controls .zoom-control input[type=range] {
  /* Firefox */
}
.cropper-controls .zoom-control input[type=range]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #FF6A56;
  border: 2px solid #FF6A56;
  cursor: pointer;
}
.cropper-controls .zoom-control input[type=range] {
  /* IE */
}
.cropper-controls .zoom-control input[type=range]::-ms-thumb {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #FF6A56;
  border: 2px solid #FF6A56;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.cropper-controls .cropper-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 120px;
}

.cropper-popup .popup-container {
  width: 80%;
  max-width: 400px;
}

.alert-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 88%;
  max-width: 400px;
  display: flex;
  justify-content: center;
  pointer-events: none;
}
.alert-container.alert-entering {
  animation: slideDown 0.3s forwards;
}
.alert-container.alert-enter-instant {
  animation: none;
}
.alert-container.alert-leaving {
  animation: slideUp 0.3s forwards;
}
@media screen and (max-width: 760px) {
  .alert-container {
    top: 10px;
  }
}

.alert {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  padding: 12px 20px 12px 12px;
  display: flex;
  align-items: center;
  min-width: 200px;
  pointer-events: auto;
}
.alert .alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .alert-icon svg {
  width: 26px;
  height: 26px;
  color: #FFFFFF;
}
.alert .alert-message {
  flex: 1 1;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  color: #FFFFFF;
}
.alert .alert-close {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .alert-close svg {
  width: 24px;
  height: 24px;
  opacity: 0.6;
  color: #FFFFFF;
  transition: opacity 0.2s ease;
  stroke-width: 2px;
}
.alert .alert-close:hover svg {
  opacity: 1;
  scale: 1.1;
}
.alert.alert-success {
  background-color: #00DEA3;
}
.alert.alert-error {
  background-color: #D90D3E;
}
.alert.alert-warning {
  background-color: #FF6A56;
}
.alert.alert-info {
  background-color: #15A6F8;
}
.alert.alert-loading {
  border: 2px solid #261147;
}
.alert.alert-loading .alert-message {
  color: #261147;
}
.alert.alert-loading svg {
  color: #261147;
}
@media screen and (max-width: 760px) {
  .alert {
    padding: 10px 18px 10px 10px;
  }
  .alert .alert-message {
    font-size: 15px;
  }
}

/* Alert test buttons styling */
.alert-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

@keyframes slideDown {
  from {
    transform: translateY(-80px) translateX(-50%);
    transition: transform 0.3s ease;
  }
  to {
    transform: translateY(0) translateX(-50%);
    transition: transform 0.3s ease;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(0) translateX(-50%);
    transition: transform 0.3s ease;
  }
  to {
    transform: translateY(-80px) translateX(-50%);
    transition: transform 0.3s ease;
  }
}
.menu-dropdown {
  position: relative;
  display: inline-block;
}
.menu-dropdown .menu-panel {
  position: absolute;
  top: calc(100% + 4px);
  min-width: 148px;
  background-color: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding: 0;
  z-index: 1000;
  border: 2px solid #F5F6FA;
  overflow: hidden;
  will-change: transform, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
}
.menu-dropdown .menu-panel.align-right {
  right: 0;
}
.menu-dropdown .footer-menu {
  bottom: 100% !important;
  top: auto !important;
  margin-bottom: 8px;
  min-width: 168px !important;
}
.menu-dropdown .menu-items {
  list-style: none;
  margin: 0;
  padding: 0;
  padding: 10px 0;
}
.menu-dropdown .menu-items .menu-item a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  padding: 5px 8px;
  color: #261147;
  text-decoration: none;
}
.menu-dropdown .menu-items .menu-item svg, .menu-dropdown .menu-items .menu-item .icon svg {
  width: 24px;
  height: 24px;
  color: #BBBDD6;
}
.menu-dropdown .menu-items .menu-item:hover a {
  background-color: #F5F6FA;
}
.menu-dropdown .menu-items .menu-item.disabled a {
  color: #BBBDD6;
  pointer-events: none;
}
@media screen and (max-width: 768px) {
  .menu-dropdown .menu-items .menu-item a {
    padding: 8px;
  }
  .menu-dropdown .menu-items .menu-item svg, .menu-dropdown .menu-items .menu-item .icon svg {
    width: 26px;
    height: 26px;
  }
}

.menu {
  padding: 0 8px;
  gap: 0px;
}
.menu .svg-icon {
  display: none;
  stroke-width: 1.6px;
}
@media screen and (max-width: 400px) {
  .menu {
    padding: 0 6px;
  }
  .menu .svg-icon {
    display: block;
  }
  .menu span {
    display: none;
  }
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 8px;
  font-size: 32px;
  line-height: 1;
  font-weight: 4 0;
  color: #261147;
}

.label {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  width: 100%;
  flex: 1 1;
  width: 100%;
}
.label span {
  font-size: 18px;
  color: #FF6A56;
}

.muted-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #BBBDD6;
  font-size: 28px;
  padding: 48px 0;
  height: 100%;
  width: 100%;
  margin-bottom: 100px;
  flex: 1 1;
}
.muted-text svg {
  width: 110px;
  height: auto;
  stroke-width: 2px;
  transition: all 0.2s ease;
  color: #BBBDD6;
  padding: 0;
}

.no-underline {
  text-decoration: none;
}

.column-center-gap-8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.responsive-image-container {
  width: 100%;
  position: relative;
}
.responsive-image-container .responsive-image {
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}
.responsive-image-container .responsive-image.desktop-image {
  display: block;
}
.responsive-image-container .responsive-image.mobile-image {
  display: none;
}
@media screen and (max-width: 600px) {
  .responsive-image-container .responsive-image.desktop-image {
    display: none;
  }
  .responsive-image-container .responsive-image.mobile-image {
    display: block;
  }
}

.countdown-container .countdown-timer .countdown-time {
  font-size: 2rem;
  font-weight: 700;
  color: #261147;
  font-family: "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", monospace;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.confirm-verification__container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F9FAFC;
  padding: 2rem 1rem;
}
.confirm-verification__wrapper {
  max-width: 480px;
  width: 100%;
}
.confirm-verification__card {
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(38, 17, 71, 0.08);
  border: 1px solid #DEDEEB;
  overflow: hidden;
}
.confirm-verification__header {
  padding: 2rem;
  text-align: center;
  border-bottom: 1px solid #DEDEEB;
}
.confirm-verification__icon-container {
  margin: 0 auto 1.5rem;
  height: 4rem;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.confirm-verification__icon-container--verifying {
  background-color: #F0F0F9;
}
.confirm-verification__icon-container--success {
  background-color: rgba(0, 222, 163, 0.1);
}
.confirm-verification__icon-container--error {
  background-color: rgba(217, 13, 62, 0.1);
}
.confirm-verification__spinner {
  animation: spin 1s linear infinite;
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  border: 3px solid #CCCEDE;
  border-top-color: #261147;
}
.confirm-verification__status-icon {
  height: 2rem;
  width: 2rem;
}
.confirm-verification__status-icon--success {
  color: #00DEA3;
}
.confirm-verification__status-icon--error {
  color: #D90D3E;
}
.confirm-verification__title {
  font-size: 24px;
  font-weight: 600;
  color: #261147;
  margin-bottom: 0.5rem;
}
.confirm-verification__subtitle {
  color: #513C6A;
  font-size: 16px;
  line-height: 1.4;
}
.confirm-verification__content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.confirm-verification__message {
  padding: 1rem;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.4;
}
.confirm-verification__message--success {
  background-color: rgba(0, 222, 163, 0.1);
  color: #261147;
  border: 1px solid rgba(0, 222, 163, 0.2);
}
.confirm-verification__message--error {
  background-color: rgba(217, 13, 62, 0.1);
  color: #261147;
  border: 1px solid rgba(217, 13, 62, 0.2);
}
.confirm-verification__message--info {
  background-color: #F0F0F9;
  color: #513C6A;
  border: 1px solid #DEDEEB;
}
.confirm-verification__actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.confirm-verification__button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 52px;
  padding: 0 1rem;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}
.confirm-verification__button--primary {
  background-color: #261147;
  color: #FFFFFF;
  border: 2px solid #261147;
}
.confirm-verification__button--primary:hover {
  background-color: #FF6A56;
  border-color: #FF6A56;
}
.confirm-verification__button--secondary {
  background-color: transparent;
  color: #261147;
  border: 2px solid #261147;
}
.confirm-verification__button--secondary:hover {
  background-color: #261147;
  color: #FFFFFF;
}
.confirm-verification__button--outline {
  background-color: transparent;
  color: #FF6A56;
  border: 2px solid #FF6A56;
}
.confirm-verification__button--outline:hover {
  background-color: #FF6A56;
  color: #FFFFFF;
}
.confirm-verification__loading {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.confirm-verification__dots {
  display: flex;
  justify-content: center;
  gap: 0.25rem;
}
.confirm-verification__dots .dot {
  height: 0.5rem;
  width: 0.5rem;
  background-color: #261147;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}
.confirm-verification__dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}
.confirm-verification__dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}
.confirm-verification__dots .dot:nth-child(3) {
  animation-delay: 0s;
}
.confirm-verification__footer {
  text-align: center;
  margin-top: 1.5rem;
  color: #878BBA;
  font-size: 14px;
}
.confirm-verification__support-link {
  color: #FF6A56;
  text-decoration: none;
}
.confirm-verification__support-link:hover {
  text-decoration: underline;
}
.confirm-verification__helper-text {
  text-align: center;
  color: #878BBA;
  font-size: 14px;
  margin-top: 0.5rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/styles/atom.scss"],"names":[],"mappings":"AAkCA;EACI,cAAA;EACA,SAAA;EACA,iCAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AC1BJ;;AD6BA;EACI,gBAAA;EACA,cAxCG;EAyCH,yBAtCI;ACYR;;AD6BA;EACI,qBAAA;AC1BJ;;AD6BA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AC1BJ;;AD6BA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAjEG;EAkEH,aAAA;EACA,eAAA;EACA,kBAAA;AC1BJ;;AAvCA;EACE,iCAAA;EACA,cDJO;AC8CT;;AAvCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBDNK;ECOL,mBAAA;AA0CF;AAxCE;EACE,eAAA;EACA,cDtBK;ACgET;;AAnCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,cD3BM;EC4BN,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBDxCK;ECyCL,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AAsCF;AAhCE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAkCJ;AA/BE;EACE,yBD3DK;EC4DL,yBAAA;EACA,cDrDI;ECsDJ,yBAAA;AAiCJ;AA/BI;EACE,cDzDE;AC0FR;AA7BE;EAxCF;IAyCI,YAAA;EAgCF;AACF;;AA5BA;EACE,YAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AA+BF;AA7BE;EACE,uCAAA;EACA,cD3EI;EC4EJ,qCAAA;EACA,yBAAA;AA+BJ;AA5BE;EAbF;IAcK,cAAA;IACA,eAAA;EA+BH;AACF;;AA3BA;EACE,cDjGK;ECkGL,6BAAA;EACA,yBAAA;EACA,cDpGK;ACkIP;;AA1BA;EACE,cDzGK;EC0GL,6BAAA;EACA,yBAAA;EACA,cD3GO;ACwIT;;AAzBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,cD3HK;EC4HL,YAAA;AA4BF;AA1BE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AA4BJ;AAzBE;EACE,cDrIK;ECsIL,yBD1HG;EC2HH,6BAAA;AA2BJ;AAzBI;EACE,cD1IG;EC2IH,6BAAA;AA2BN;;AArBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAwBF;AAtBE;EACE,eAAA;EACA,eAAA;AAwBJ;AArBE;EACE,cDlJG;ECmJH,yBDxJG;ECyJH,yBAAA;AAuBJ;AArBI;EACE,kCAAA;AAuBN;AAnBE;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAqBJ;AAnBI;EACE,cAAA;AAqBN;AAjBE;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAmBJ;AAjBI;EACE,cAAA;AAmBN;;AAdA;EACE;IAAO,uBAAA;EAkBP;EAjBA;IAAK,yBAAA;EAoBL;AACF;AAhBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAkBF;;AAfA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,yBD/MM;ECgNN,WAAA;EACA,sBAAA;AAkBF;AAhBE;EACE,qBDxNG;AC0OP;AAhBI;EACE,cD3NC;AC6OP;AAdI;EACA,qBD9NE;AC8ON;AAfI;EACE,cDhOA;ACiPN;AAbE;EACE,aAAA;EACA,mBAAA;EACA,cD5NG;AC2OP;AAbI;EACE,WAAA;EACA,YAAA;AAeN;AAXE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAaJ;AAVE;EACE,cDxPG;ACoQP;AATE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,cDrQG;ECsQH,WAAA;AAWJ;AATI;EACE,cDlQA;AC6QN;AARI;EACE,cD3PC;EC4PD,oBAAA;AAUN;AAPI;EACE,cDlQC;AC2QP;AAJE;EAxEF;IAyEI,YAAA;EAOF;AACF;;AALI;EACE,cD3QC;ACmRP;;AALA;EACE,sBAAA;EACA,kBAAA;AAQF;AANE;EACE,cDpSG;ECqSH,gBAAA;EACA,eAAA;EACA,iBAAA;AAQJ;;AAHA;EACE,kBAAA;EACA,WAAA;AAMF;AAJE;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;AAMJ;AAJI;EACE,aAAA;EACA,4BAAA;EACA,YAAA;AAMN;AAFE;EAlBF;IAmBI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,WAAA;EAKF;EAHE;IACE,gBAAA;EAKJ;EAHI;IACE,SAAA;IACA,mBAAA;IACA,YAAA;EAKN;AACF;AACI;EACE,yBDnVC;ECoVD,qBDpVC;ECqVD,cD5UE;EC6UF,yBAAA;AACN;AACM;EACE,yBDxVC;ECyVD,qBDzVC;AC0VT;AACM;EACE,yBD7UD;EC8UC,qBD9UD;EC+UC,YAAA;AACR;AAOI;EACE,yBDnWC;ECoWD,qBDpWC;ECqWD,cDjWE;ECkWF,yBAAA;AALN;AAOM;EAAY,cDpWV;ACgWR;AAMM;EACE,oEAAA;EACA,gEAAA;AAJR;AAUI;EACE,yBDzXE;EC0XF,qBD1XE;EC2XF,cDjXE;ECkXF,yBAAA;AARN;AAUM;EAAY,cDpXV;AC6WR;AASM;EACE,8CAAA;EACA,0CAAA;AAPR;AAaI;EACE,yBDjYA;ECkYA,qBDlYA;ECmYA,cDjYE;ECkYF,yBAAA;AAXN;AAaM;EAAY,cDpYV;AC0XR;AAYM;EACE,mEAAA;EACA,+DAAA;AAVR;AAYM;EACE,YAAA;AAVR;AAYQ;EAAU,yBD/YZ;EC+YoC,qBD/YpC;ACuYN;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cDtaO;ACyZT;AAeE;EACE,WAAA;AAbJ;;AAkBA;EACE,kBAAA;AAfF;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBD9aI;EC+aJ,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cDxcG;ECycH,aAAA;EACA,yBAAA;AAhBJ;AAkBI;EACE,yBDjcC;ECkcD,cD9cC;AC8bP;AAoBE;EACE,yBDvcG;ECwcH,cDpdG;ACkcP;AAqBE;EACE,eAAA;AAnBJ;;AAyBE;EACE,eAAA;EACA,cD/dK;ECgeL,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;AAtBJ;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAzBF;AA2BE;EACE,cD/eK;ACsdT;AA4BE;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cD1eG;EC2eH,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yBDrfI;AC2dR;AA4BI;EACE,WAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,yBDrgBG;ECsgBH,qBDtgBG;ECugBH,cD/fE;ACoeR;AA8BI;EAxBF;IAyBI,WAAA;IACA,YAAA;EA3BJ;AACF;AA8BE;EACE,eAAA;AA5BJ;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;AA/BF;AAiCE;EACE,YAAA;EACA,mBAAA;AA/BJ;AAkCI;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EAEA,yBD9hBC;EC+hBD,mBAAA;EACA,yBAAA;AAjCN;AAmCI;EACE,yBDjjBG;ECkjBH,qBDljBG;ACihBT;AAoCI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,yBDnjBE;ECojBF,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlCN;AAoCM;EACE,WAAA;EACA,YAAA;EACA,cDvjBD;ECwjBC,aAAA;AAlCR;AAqCM;EACE,2BAAA;AAnCR;AAqCQ;EACE,cD7kBD;AC0iBT;AAyCE;EACE,eAAA;EACA,cDtlBG;ECulBH,gBAAA;AAvCJ;AA2CI;EACE,yBD5kBC;EC6kBD,qBD7kBC;EC8kBD,yBAAA;AAzCN;AA2CM;EACE,4CAAA;EACA,wCAAA;AAzCR;AA8CI;EAEE;IACC,cAAA;IACD,oBAAA;IACA,wBAAA;IACA,cAAA;IACA,qBAAA;IACA,yBAAA;EA7CJ;EAgDI;IACA,WAAA;IACA,YAAA;IACA,SAAA;IACA,QAAA;EA9CJ;AACF;;AAqDA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAlDF;AAoDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cD7oBK;EC8oBL,kBAAA;EACA,eAAA;EACA,iCAAA;AAlDJ;AAoDI;EACE,yBDnpBG;ECopBH,cD5oBE;AC0lBR;AAqDI;EACE,YAAA;EACA,WAAA;AAnDN;AAsDI;EAzBF;IA0BI,YAAA;EAnDJ;AACF;;AAyDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAtDF;AAwDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,cDrrBK;ECsrBL,eAAA;EACA,gCAAA;AAtDJ;AAwDI;EACE,yBD1rBG;EC2rBH,cDnrBE;AC6nBR;AAyDI;EACE,yBD/rBG;ECgsBH,cDxrBE;ACioBR;AA0DI;EACE,YAAA;EACA,WAAA;AAxDN;AA4DE;EArCF;IAsCI,YAAA;EAzDF;AACF;;AA8DA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AA3DF;AA6DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3DJ;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA3DN;AA6DM;EACE,WAAA;EACA,YAAA;EACA,cDrtBD;AC0pBP;AA8DM;EACE,cDxtBD;ECytBC,sBAAA;AA5DR;AA+DM;EACE,cD1uBD;AC6qBP;AA8DS;EACC,cD5uBH;ACgrBP;AAiEI;EACE,eAAA;AA/DN;AAkEI;EACE,cDpvBA;ACorBN;AAoEE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAlEJ;AAoEI;EACE,cDxvBC;ECyvBD,kBAAA;AAlEN;AAqEI;EACE,qBDzwBC;EC0wBD,aAAA;AAnEN;AAsEI;EAEE,cD/wBC;AC0sBP;;AA0EA;EACE,kBAAA;AAvEF;AAyEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,yBDzxBI;EC0xBJ,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAvEJ;AA0EE;EACE,iBAAA;AAxEJ;;AA8EA;EACE,kBAAA;EACA,WAAA;AA3EF;AA8EE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA5EJ;AA8EI;EACE,WAAA;EACA,YAAA;EACA,cD9yBC;ACkuBP;AA+EI;EACE,qBDl0BG;ACqvBT;AAgFI;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,cD30BC;AC6vBP;AAgFM;EACE,cDv0BF;ACyvBN;AAiFM;EACE,cDj0BD;ACkvBP;AAqFE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBDr1BI;ECs1BJ,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AAnFJ;AAqFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,cD32BC;ACwxBP;AAqFM;EACE,yBDl2BD;AC+wBP;AAsFM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AApFR;AAuFM;EACE,yBD32BD;ACsxBP;AAwFM;EACE,yBD/2BD;ECg3BC,YAAA;AAtFR;AA2FE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAzFJ;;AA8FA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA3FF;AA6FE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBDn5BI;ECo5BJ,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AA3FJ;AA6FI;EAbF;IAcI,aAAA;EA1FJ;EA4FI;IACE,YAAA;IACA,mBAAA;EA1FN;AACF;AA6FM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,cDz7BC;AC81BT;AA6FQ;EACE,yBD57BD;EC67BC,yBAAA;EACA,cDt7BF;AC21BR;AA+FM;EACE,eAAA;EACA,cDl7BD;ACq1BP;;AAmGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAhGF;;AAmGA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,cDr9BO;ACq3BT;;AAmGA;EACE,eAAA;EACA,cD19BO;EC29BP,SAAA;EACA,gBAAA;AAhGF;;AAmGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cDv9BK;ACu3BP;AAkGE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AAhGJ;AAmGE;EACE,cD/+BK;ECg/BL,UAAA;AAjGJ;;AAqGA;EACE,kBAAA;AAlGF;;AAqGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAlGF;AAqGI;EACE,cDpgCG;ACi6BT;;AA0GE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAvGJ;AA0GE;EACE,eAAA;EACA,gBAAA;EACA,cDpgCG;ECqgCH,kBAAA;EACA,SAAA;AAxGJ;AA0GI;EACE,cD3hCG;EC4hCH,gBAAA;AAxGN;AA4GE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,yBD3hCG;EC4hCH,mBAAA;EACA,WAAA;AA1GJ;AA6GE;EACE,eAAA;EACA,cD7iCK;EC8iCL,mBAAA;AA3GJ;AA8GE;EACE,eAAA;EACA,cDjiCG;ECkiCH,kBAAA;EACA,SAAA;AA5GJ;;AAkHA;EACE,kBAAA;EACA,yBDljCK;ECmjCL,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AA/GF;AAiHE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,yBDlkCG;ECmkCH,kBAAA;EACA,WAAA;AA/GJ;AAkHE;EACE,qBDjlCG;ECklCH,6CAAA;AAhHJ;AAmHE;EACE,qBD7kCG;AC49BP;AAoHE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cDplCG;ECqlCH,kBAAA;AAlHJ;AAoHI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cD3lCC;EC4lCD,yBAAA;AAlHN;AAqHI;EACE,eAAA;EACA,cDhmCC;ECimCD,eAAA;AAnHN;AAuHE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArHJ;AAwHE;EACE,uCAAA;AAtHJ;AAwHI;EACE,cDxnCE;ACkgCR;AAyHI;EACE,mBAAA;EACA,cD7nCE;EC8nCF,UAAA;EACA,yBAAA;AAvHN;AA2HE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cD9oCI;EC+oCJ,QAAA;EACA,uCAAA;AAzHJ;AA2HI;EACE,uCAAA;EACA,cDppCE;ECqpCF,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAzHN;AA2HM;EACF,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACI,mBAAA;AAzHR;AA4HM;EACE,yBD9qCF;EC+qCE,qBAAA;AA1HR;AA6HW;EAAkB,yBDlrCvB;ACwjCN;AA2HO;EAAmB,yBD3rClB;ACmkCR;AA4HM;EACE,yBDhsCA;ECisCA,qBAAA;AA1HR;AA+HE;EACE,UAAA;AA7HJ;;AAmIA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBDtsCK;ECusCL,yBAAA;AAhIF;AAkIE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAhIJ;AAmIE;EAjBF;IAkBI,YAAA;IACA,aAAA;IACA,yBAAA;EAhIF;AACF;;AAoIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAjIF;AAmIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjIJ;AAmII;EACE,cDhuCC;ECiuCD,eAAA;EACA,eAAA;AAjIN;AAoII;EACE,SAAA;EACA,WAAA;EAEA,gBAAA;EACA,+DAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAlIN;AAoIM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBD5vCD;EC6vCC,mBAAA;EACA,WAAA;AAlIR;AA+GI;EAsBE,kCAAA;AAlIN;AAmIM;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBDnxCC;ECoxCD,yBAAA;EACA,eAAA;AAjIR;AAkGI;EAkCE,YAAA;AAjIN;AAkIM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBD7xCC;EC8xCD,yBAAA;EACA,eAAA;AAhIR;AAuFI;EA4CE,OAAA;AAhIN;AAiIM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBDvyCC;ECwyCD,yBAAA;EACA,eAAA;EACA,wCAAA;AA/HR;AAoIE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;AAlIJ;;AAuIA;EACE,UAAA;EACA,gBAAA;AApIF;;AAwIA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AArIF;AAwIE;EACE,kCAAA;AAtIJ;AA0IE;EACE,eAAA;AAxIJ;AA2IE;EACE,gCAAA;AAzIJ;AA4IE;EA1BF;IA2BI,SAAA;EAzIF;AACF;;AA4IA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAzIF;AA2IE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAzIJ;AA2II;EACE,WAAA;EACA,YAAA;EACA,cDz2CE;ACguCR;AA6IE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cDl3CI;ACuuCR;AA8IE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5IJ;AA8II;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,cDj4CE;ECk4CF,6BAAA;EACA,iBAAA;AA5IN;AA+II;EACE,UAAA;EACA,UAAA;AA7IN;AAiJE;EACE,yBDv5CI;ACwwCR;AAkJE;EACE,yBDn5CE;ACmwCN;AAmJE;EACE,yBD75CK;AC4wCT;AAoJE;EACE,yBD75CG;AC2wCP;AAqJE;EAEE,yBAAA;AApJJ;AAqJI;EACA,cDz6CG;ACsxCP;AAqJI;EACE,cD56CC;ACyxCP;AAuJI;EAlFJ;IAmFK,4BAAA;EApJH;EAsJG;IACC,eAAA;EApJJ;AACF;;AAwJA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AArJF;;AAwJA;EACE;IACE,6CAAA;IACA,+BAAA;EArJF;EAuJA;IACE,yCAAA;IACA,+BAAA;EArJF;AACF;AAwJA;EACE;IACE,yCAAA;IACA,+BAAA;EAtJF;EAwJA;IACE,6CAAA;IACA,+BAAA;EAtJF;AACF;AA0JA;EACE,kBAAA;EACA,qBAAA;AAxJF;AAkKE;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBDj+CI;ECk+CJ,mBAAA;EACA,wCAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,+BAAA;EACA,wBAAA;EACA,2BAAA;AAhKJ;AAkKI;EACE,QAAA;AAhKN;AAoKI;EACO,uBAAA;EACH,oBAAA;EACA,kBAAA;EACA,2BAAA;AAlKR;AAqKE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAnKJ;AAsKM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,gBAAA;EACA,cD9gDD;EC+gDC,qBAAA;AApKR;AAuKK;EACG,WAAA;EACA,YAAA;EACA,cDpgDD;AC+1CP;AAwKM;EACE,yBD7gDD;ACu2CP;AAyKM;EACE,cD5gDD;EC6gDC,oBAAA;AAvKR;AA0KI;EAEE;IACE,YAAA;EAzKN;EA2KG;IACG,WAAA;IACA,YAAA;EAzKN;AACF;;AAgMA;EACE,cAAA;EACA,QAAA;AA7LF;AA+LE;EACE,aAAA;EACA,mBAAA;AA7LJ;AAgME;EATF;IAUI,cAAA;EA7LF;EA+LG;IACD,cAAA;EA7LF;EAgMA;IACE,aAAA;EA9LF;AACF;;AAoMA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EAEA,eAAA;EACA,cAAA;EACA,gBAAA;EAEA,cDrmDK;ACi6CP;;AAwMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EAEA,WAAA;EACA,SAAA;EACA,WAAA;AAtMF;AAyMA;EACE,eAAA;EAEA,cDtnDO;AC86CT;;AAgNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cDpnDK;ECqnDL,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAEA,SAAA;AA9MF;AAgNE;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,cDloDG;ECmoDH,UAAA;AA9MJ;;AAkNA;EACE,qBAAA;AA/MF;;AAkNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AA/MF;;AAqNE;EACE,WAAA;EACA,kBAAA;AAlNJ;AAqNE;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;AAnNJ;AAqNI;EACE,cAAA;AAnNN;AAsNI;EACE,aAAA;AApNN;AAuNI;EACE;IACE,aAAA;EArNN;EAwNI;IACE,cAAA;EAtNN;AACF;;AAiOI;EACE,eAAA;EACA,gBAAA;EACA,cD7sDC;EC8sDD,yEAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,yCAAA;AA9NN;;AAsOE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBDptDG;ECqtDH,kBAAA;AAnOJ;AAsOE;EACE,gBAAA;EACA,WAAA;AApOJ;AAuOE;EACE,mBDhuDI;ECiuDJ,mBAAA;EACA,6CAAA;EACA,yBAAA;EACA,gBAAA;AArOJ;AAwOE;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;AAtOJ;AAyOE;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAvOJ;AAyOI;EACE,yBDnvDC;AC4gDP;AA0OI;EACE,wCAAA;AAxON;AA2OI;EACE,wCAAA;AAzON;AA6OE;EACE,kCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBDlxDG;ACuiDP;AA8OE;EACE,YAAA;EACA,WAAA;AA5OJ;AA8OI;EACE,cD3xDE;AC+iDR;AA+OI;EACE,cDvxDA;AC0iDN;AAiPE;EACE,eAAA;EACA,gBAAA;EACA,cDryDG;ECsyDH,qBAAA;AA/OJ;AAkPE;EACE,cDpyDG;ECqyDH,eAAA;EACA,gBAAA;AAhPJ;AAmPE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAjPJ;AAoPE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAlPJ;AAoPI;EACE,wCAAA;EACA,cD9zDC;EC+zDD,wCAAA;AAlPN;AAqPI;EACE,wCAAA;EACA,cDp0DC;ECq0DD,wCAAA;AAnPN;AAsPI;EACE,yBD5zDC;EC6zDD,cDp0DC;ECq0DD,yBAAA;AApPN;AAwPE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAtPJ;AAyPE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAvPJ;AAyPI;EACE,yBDv2DC;ECw2DD,cD/1DE;ECg2DF,yBAAA;AAvPN;AAyPM;EACE,yBD32DC;EC42DD,qBD52DC;ACqnDT;AA2PI;EACE,6BAAA;EACA,cDn3DC;ECo3DD,yBAAA;AAzPN;AA2PM;EACE,yBDv3DD;ECw3DC,cD/2DA;ACsnDR;AA6PI;EACE,6BAAA;EACA,cD73DG;EC83DH,yBAAA;AA3PN;AA6PM;EACE,yBDj4DC;ECk4DD,cD13DA;AC+nDR;AAgQE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9PJ;AAiQE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AA/PJ;AAiQI;EACE,cAAA;EACA,aAAA;EACA,yBDv5DC;ECw5DD,kBAAA;EACA,gDAAA;AA/PN;AAiQM;EAAiB,uBAAA;AA9PvB;AA+PM;EAAiB,uBAAA;AA5PvB;AA6PM;EAAiB,mBAAA;AA1PvB;AA8PE;EACE,kBAAA;EACA,kBAAA;EACA,cDj5DG;ECk5DH,eAAA;AA5PJ;AA+PE;EACE,cDx6DK;ECy6DL,qBAAA;AA7PJ;AA+PI;EACE,0BAAA;AA7PN;AAiQE;EACE,kBAAA;EACA,cDh6DG;ECi6DH,eAAA;EACA,kBAAA;AA/PJ;;AAmQA;EACE;IACE,yBAAA;EAhQF;AACF;AAmQA;EACE;IACE,mBAAA;EAjQF;EAmQA;IACE,mBAAA;EAjQF;AACF","sourcesContent":["$Green: #00DEA3;\n$Dark: #261147;\n$Orange: #FF6A56;\n$Yellow: #FEA300;\n$Pink: #FF3A81;\n$Purple: #9648DE;\n$Blue: #15A6F8;\n$Text: #513C6A;\n$Red: #D90D3E;\n\n$White: #FFFFFF;\n$W_20: #ffffff31;\n$G_00: #F9FAFC;\n$G_01: #F5F6FA;\n$G_02: #F0F0F9;\n$G_03: #ebebf9;\n$G_04: #DEDEEB;\n$G_05: #CCCEDE;\n$G_06: #BBBDD6;\n$G_07: #ABADC8;\n$G_08: #878BBA;\n$G_09: #64677f;\n\n\n@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1+Code:wght@100..700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Sen:wght@400;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@100..900&display=swap');\n\n\n\n* {\n    color: inherit;\n    margin: 0;\n    font-family: \"Outfit\", sans-serif;\n    font-size: 18px;\n    box-sizing: border-box;\n    letter-spacing: 0.02em;\n    font-weight: 400;\n    line-height: 1.3;\n}\n\nbody {\n    font-weight: 400;\n    color: $Text;\n    background-color: $White;\n}\n\na {\n    text-decoration: none;\n}\n\nsvg {\n    width: 32px;\n    height: 32px;\n    stroke-width: 1.5px;\n}\n\n.home {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-items: center;\n    color: $Dark;\n    padding: 24px;\n    font-size: 32px;\n    text-align: center;\n\n}","@import \"../styles/vars.scss\";\n\n\n// - - - - - - - - - - -  Design System - - - - - - - - - -\n.page-title {\n  font-size: clamp(24px, 4vw, 32px);\n  color: $Orange;\n}\n\n.main_box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: 80%;\n  max-width: 560px;\n  padding: 16px 32px 32px;\n  margin: 12px 0;\n  background-color: $G_01;\n  border-radius: 16px;\n\n  .ds_title {\n    font-size: 27px;\n    color: $Orange;\n  }\n}\n\n\n// - - - - - - - - - - - BUTTON TEMP - - - - - - - - - - \n\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: none;\n  border-radius: 10px;\n  color: $White;\n  border: solid 2px $Dark;\n  cursor: pointer;\n  position: relative;\n  background-color: $Dark;\n  width: 100%;\n  height: 52px;\n  padding: 0 8px 0 8px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n  line-height: 100%;\n\n  // span {\n  //   margin: 0 8px;\n  // }\n\n  .svg-icon {\n    width: 26px;\n    height: auto;\n    min-width: 26px;\n    transition: fill 0.3s ease;\n  }\n\n  &:hover {\n    background-color: $Orange;\n    border: solid 2px $Orange;\n    color: $White;\n    transition: all 0.2s ease;\n\n    .svg-icon {\n      color: $White;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    height: 54px;\n  }\n\n}\n// - - - - - - - - - SMALL\n.small {\n  height: 38px;\n  padding: 0 12px;\n  justify-content: center;\n  text-align: center;\n\n  &:hover {\n    background-color: rgba($Dark, 0.7);\n    color: $White;\n    border: solid 2px rgba($Dark, 0);\n    transition: all 0.2s ease;\n  }\n\n  @media screen and (max-width: 768px) {\n     padding: 0 8px;\n     font-size: 16px;\n  }\n}\n\n// - - - - - - - - LINED BUTTON \n.lined {\n  color: $Dark;\n  background-color: transparent;\n  border: solid 2px $Dark;\n  color: $Dark;\n}\n\n// - - - - - - SECONDARY BUTTON \n.sec {\n  color: $Dark;\n  background-color: transparent;\n  border: solid 2px $Orange;\n  color: $Orange;\n}\n\n// - - - - - -- NAVIGATION BUTTON\n.nav-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0px;\n  border: none;\n  height: auto;\n  width: fit-content;\n  background-color: transparent;\n  border: solid 2px transparent;\n  color: $Dark;\n  padding: 4px;\n\n  .svg-icon {\n    width: 36px;\n    height: 36px;\n    stroke-width: 1.3px;\n    border: solid 2px transparent;\n  }\n\n  &:hover {\n    color: $Orange;\n    background-color: $G_02;\n    border: 2px solid transparent;\n\n    .svg-icon {\n      color: $Orange;\n      border: solid 2px transparent;\n    }\n  }\n}\n\n// - - - - - - - - - - - VALIDATION MESSAGES - - - - - - - - - - \n.validation-message {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  margin-top: 4px;\n  margin-bottom: 8px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n\n  .spinner, .check, .cross {\n    font-size: 16px;\n    min-width: 16px;\n  }\n\n  &.checking {\n    color: $G_06;\n    background-color: $G_01;\n    border: 1px solid $G_02;\n    \n    .spinner {\n      animation: spin 1s linear infinite;\n    }\n  }\n\n  &.success {\n    color: #22c55e;\n    background-color: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    \n    .check {\n      color: #22c55e;\n    }\n  }\n\n  &.error {\n    color: #ef4444;\n    background-color: #fef2f2;\n    border: 1px solid #fecaca;\n    \n    .cross {\n      color: #ef4444;\n    }\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n// - - - - - - - - -  - INPUTS TEMP - - - - - - - - -\n\n.input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 4px;\n}\n\n.input-icon-box {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 2px solid $G_04;\n  border-radius: 12px;\n  padding: 0 12px;\n  height: 52px;\n  transition: all 0.3s;\n  background-color: $White;\n  width: 100%;\n  box-sizing: border-box;\n\n  &.focused {\n    border-color: $Blue;\n\n    .icon {\n      color: $Blue;\n    }\n  }\n\n    &.error {\n    border-color: $Red;\n    .icon {\n      color: $Red;\n    }\n  }\n\n  .icon {\n    display: flex;\n    align-items: center;\n    color: $G_07;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .input-wrapper {\n    display: flex;\n    flex: 1;\n    align-items: center;\n  }\n\n  .input-prefix {\n    color: $Blue;\n  }\n\n  .input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    color: $Dark;\n    width: 100%;\n\n    &.no-match {\n      color: $Red;\n    }\n\n    &::placeholder {\n      color: $G_07;\n      transition: all 0.3s;\n    }\n\n    &:focus::placeholder {\n      color: $G_05\n    }\n\n  }\n\n  @media screen and (max-width: 768px) {\n    height: 56px;\n  }\n}\n    .char-counter{\n      color: $G_06;\n    }\n// - - - - - - - WITH LABEL\n.with-label {\n  flex-direction: column;\n  align-items: start;\n\n  .input-label {\n    color: $Dark;\n    text-align: left;\n    padding: 0 16px;\n    text-wrap: nowrap;\n  }\n}\n\n// - - - - - - - - - COMPACT FIELD \n.compact-field-hero {\n  position: relative;\n  width: 100%;\n\n  .compact-button {\n    position: absolute;\n    right: 2px;\n    top: 0;\n    z-index: 1;\n    height: calc(100% - 4px);\n\n    .button {\n      margin: 2px 0;\n      border-radius: 0 10px 10px 0;\n      height: 100%;\n    }\n  }\n\n  @media screen and (max-width: 1000px) {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    position: static;\n    width: 100%;\n\n    .compact-button {\n      position: static;\n\n      .button {\n        margin: 0;\n        border-radius: 10px;\n        height: 54px;\n      }\n    }\n  }\n\n  // Status-driven styles for CompactField button\n  &.status-neutral {\n    .compact-button .button {\n      background-color: $Dark;\n      border-color: $Dark;\n      color: $White;\n      transition: all 0.2s ease;\n      \n      &:hover {\n        background-color: $Orange;\n        border-color: $Orange;\n      }\n      &.disabled {\n        background-color: $G_05;\n        border-color: $G_05;\n        opacity: 0.6;\n        // cursor: not-allowed;\n        // &:hover { background-color: $Dark; border-color: $Dark; }\n      }\n    }\n  }\n\n  &.status-checking {\n    .compact-button .button {\n      background-color: $Blue;\n      border-color: $Blue;\n      color: $White;\n      transition: all 0.2s ease;\n\n      .svg-icon { color: $White; }\n\n      &:hover {\n        background-color: lighten($Blue, 5%);\n        border-color: lighten($Blue, 5%);\n      }\n    }\n  }\n\n  &.status-success {\n    .compact-button .button {\n      background-color: $Green;\n      border-color: $Green;\n      color: $White;\n      transition: all 0.2s ease;\n\n      .svg-icon { color: $White; }\n\n      &:hover {\n        background-color: lighten($Green, 5%);\n        border-color: lighten($Green, 5%);\n      }\n    }\n  }\n\n  &.status-error {\n    .compact-button .button {\n      background-color: $Red;\n      border-color: $Red;\n      color: $White;\n      transition: all 0.2s ease;\n\n      .svg-icon { color: $White; }\n\n      &:hover {\n        background-color: lighten($Red, 5%);\n        border-color: lighten($Red, 5%);\n      }\n      &.disabled {\n        opacity: 0.7;\n        // cursor: not-allowed;\n        &:hover { background-color: $Red; border-color: $Red; }\n      }\n    }\n  }\n}\n\n\n// - - - - - - - - - - - - Title - - - - - - - - - - - - \n.big-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: auto;\n  height: auto;\n  font-size: 26px;\n  font-weight: 500;\n  color: $Orange;\n\n  svg {\n    width: 32px;\n  }\n}\n\n// - - - - - - - - - - - - - Drop-Down - - - - - - - - - -\n.input-icon-box {\n  position: relative;\n\n  .dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: $White;\n    border: 2px solid $Blue;\n    border-radius: 12px;\n    max-height: 200px;\n    overflow-y: auto;\n    z-index: 1000;\n    margin-top: 4px;\n    padding: 8px 0;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    list-style: none;\n    text-align: left;\n  }\n\n  .dropdown-option {\n    padding: 12px 16px;\n    cursor: pointer;\n    font-size: 17px;\n    color: $Dark;\n    display: flex;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background-color: $G_01;\n      color: $Dark;\n    }\n  }\n\n  .selected-option {\n    background-color: $G_01;\n    color: $Dark;\n  }\n\n  .right-icon {\n    cursor: pointer;\n  }\n}\n\n// SearchBar inline meta (e.g. results count)\n.search-bar {\n  .search-bar-meta {\n    font-size: 16px;\n    color: $Orange;\n    padding: 0 2px;\n    user-select: none;\n    white-space: nowrap;\n  }\n}\n\n// - - - - - - -- - -  Check Box - - - - - - - - - - \n\n.checkbox-icon-box {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n\n  &:hover {\n    color: $Orange;\n  }\n\n  .custom-checkbox {\n    margin-right: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 2px solid $G_04;\n    color: $G_04;\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    padding: 4px;\n    background-color: $White;\n\n    svg {\n      width: 100%;\n      stroke-width: 3px;\n    }\n\n    &.checked {\n      background-color: $Orange;\n      border-color: $Orange;\n      color: $White;\n    }\n\n    @media screen and (max-width: 768px) {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .checkbox-input {\n    cursor: pointer;\n  }\n\n}\n\n// - - - - - - - - - TOGGLE SWITCH - - - - - - - - - - - - \n.toggle-switch {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  gap: 12px;\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n    .switch-track {\n      position: relative;\n      --W-size: 54px;\n      width: var(--W-size);\n      min-width: var(--W-size);\n      --h-size: 30px;\n      height: var(--h-size);\n      min-height: var(--h-size);\n\n      background-color: $G_04;\n      border-radius: 50px;\n      transition: all 0.2s ease;\n      // border: 2px solid $G_04;\n    &.checked {\n      background-color: $Orange;\n      border-color: $Orange;\n    }\n\n    .switch-thumb {\n      position: absolute;\n      width: 24px;\n      height: 24px;\n      left: 3px;\n      top: 3px;\n      background-color: $White;\n      border-radius: 50%;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        width: 20px;\n        height: 20px;\n        color: $G_04;\n        display: none;\n      }\n\n      &.checked {\n        transform: translateX(24px);\n        \n        svg {\n          color: $Orange;\n        }\n      }\n    }\n  }\n\n  .switch-label {\n    font-size: 17px;\n    color: $Dark;\n    font-weight: 400;\n  }\n\n  &:hover:not(.disabled) {\n    .switch-track {\n      background-color: $G_05;\n      border-color: $G_05;\n      transition: all 0.2s ease;\n      \n      &.checked {\n        background-color: darken($Orange, 20%);\n        border-color: darken($Orange, 20%);\n      }\n    }\n  }\n\n    @media screen and (max-width: 768px) {\n\n      .switch-track {\n       --W-size: 54px;\n      width: var(--W-size);\n      min-width: var(--W-size);\n      --h-size: 32px;\n      height: var(--h-size);\n      min-height: var(--h-size);\n\n\n      .switch-thumb {\n      width: 24px;\n      height: 24px;\n      left: 3px;\n      top: 4px;\n      }\n    }\n  }\n\n}\n\n// - - - - - - - - - TAGS - - - - - - - - - - - - \n.tag-container {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  .tag {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 0 4px;\n    width: auto;\n    height: 40px;\n    border: 2px solid $Orange;\n    color: $Orange;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n\n    &.selected {\n      background-color: $Orange;\n      color: $White;\n    }\n\n    svg {\n      height: 24px;\n      width: 24px;\n    }\n\n    @media screen and (max-width: 768px) {\n      height: 48px;\n    }\n  }\n\n}\n\n// - - - - - - - - - TABS - - - - - - - - - - - - \n.tab-container {\n  display: flex;\n  flex-direction: row;\n  height: 44px;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 2px solid $Orange;\n\n  .tab {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 0 12px;\n    width: auto;\n    color: $Orange;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n\n    &.selected {\n      background-color: $Orange;\n      color: $White;\n    }\n\n    &:hover {\n      background-color: $Orange;\n      color: $White;\n    }\n\n    svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    height: 50px;\n  }\n}\n\n// - - - - - - - - -  TEXTAREA - - - - - - - - - - \n\n.textarea-icon-box {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 4px;\n\n  .input-top-box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    padding: 0 12px;\n\n    .left-side {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      svg {\n        width: 28px;\n        height: 28px;\n        color: $G_06;\n      }\n\n      .textarea-title {\n        color: $G_07;\n        transition: color 0.3s;\n      }\n\n      .focused {\n        color: $Blue;\n         svg {\n          color: $Blue;\n        }\n      }\n    }\n\n    .char-counter {\n      font-size: 17px;\n    }\n\n    .char-counter.red {\n      color: $Red;\n    }\n  }\n\n  .input {\n    width: 100%;\n    height: 188px;\n    border: 2px solid $G_04;\n    border-radius: 12px;\n    padding: 12px;\n    box-sizing: border-box;\n    transition: border-color 0.3s;\n\n    &::placeholder {\n      color: $G_06;\n      font-style: italic;\n    }\n\n    &:focus {\n      border-color: $Blue;\n      outline: none;\n    }\n\n    &:focus~.input-top-box .textarea-title,\n    &:focus~.input-top-box .left-icon {\n      color: $Blue;\n    }\n  }\n}\n\n.compact-textarea {\n  position: relative;\n\n  .input-top-box {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 52px;\n    background-color: $White;\n    margin: 4px;\n    padding: 0 12px 0 8px;\n    display: flex;\n    align-items: center\n  }\n\n  .input {\n    padding-top: 54px;\n  }\n}\n\n// - - - - - - - -  Country Dropdown - - - - - - - \n\n.input-icon-box {\n  position: relative;\n  width: 100%;\n  // max-width: 360px;\n\n  .input-container {\n    width: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    transition: border-color 0.3s;\n\n    svg {\n      width: 28px;\n      height: 28px;\n      color: $G_06;\n    }\n\n    &.focused {\n      border-color: $Orange;\n    }\n\n    .input {\n      border: none;\n      outline: none;\n      flex: 1;\n      padding: 5px;\n      color: $Dark;\n\n      &.no-match {\n        color: $Red;\n      }\n\n      &::placeholder {\n        color: $G_06;\n      }\n    }\n\n  }\n\n  .dropdown {\n    position: absolute;\n    top: 104%;\n    left: 0;\n    right: 0;\n    z-index: 10; // Keep dropdown above other elements\n    background-color: $White;\n    border: 2px solid $Blue;\n    border-radius: 16px;\n    max-height: 200px; // Limit the height of the dropdown\n    overflow-y: auto; // Scroll if there are too many options\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); // Add shadow for better visibility\n\n    .dropdown-option {\n      display: flex; // Align items\n      align-items: center;\n      gap: 12px;\n      padding: 10px; // Space inside options\n      cursor: pointer; // Change cursor on hover\n      color: $Dark; // Default option color\n\n      &.selected {\n        background-color: $G_01; // Highlight selected option\n      }\n\n      svg {\n        width: 28px;\n        height: 28px;\n        border-radius: 24px;\n      }\n\n      &:hover {\n        background-color: $G_02; // Highlight on hover\n      }\n\n      &.highlighted {\n        background-color: $G_02;\n        color: white; // Highlighted text color\n      }\n    }\n  }\n\n  .flag-icon-in-input {\n    width: 28px; // Adjust flag size\n    height: 28px; // Adjust flag size\n    border-radius: 20px;\n  }\n}\n\n// - - - - - - - - - - - - POPUP - - - - - - - - - - - -\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba($Dark, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n\n  .popup-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    background-color: $White;\n    border-radius: 20px;\n    padding: 32px 40px;\n    width: 90%;\n    max-width: 460px;\n    position: relative;\n\n    @media screen and (max-width: 460px) {\n      padding: 24px;\n\n      .popup-illus {\n        width: 100px;\n        stroke-width: 2.8px;\n      }\n    }\n\n      .mailto-btn{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        width: 100%;\n        max-width: 460px;\n        height: 54px;\n        border-radius: 8px;\n        padding: 0 24px !important;\n        background-color: transparent;\n        border: 2px solid $Orange;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        color: $Orange;\n\n        &:hover {\n          background-color: $Orange;\n          transition: all 0.2s ease;\n          color: $White;\n        }\n      }\n\n      span{\n        font-size: 16px;\n        color: $G_08;\n        // padding: 0 8px;\n      }\n  }\n}\n\n.popup-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.popup-illus {\n  width: 120px;\n  height: auto;\n  stroke-width: 2.4px;\n  color: $Orange;\n}\n\n.popup-title {\n  font-size: 26px;\n  color: $Orange;\n  flex: 1;\n  line-height: 1.1;\n}\n\n.popup-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  color: $G_05;\n\n  svg {\n    width: 100%;\n    height: 100%;\n    transition: color 0.2s ease;\n  }\n\n  &:hover {\n    color: $Orange;\n    scale: 1.1;\n  }\n}\n\n.popup-text {\n  text-align: center;\n}\n\n.popup-children-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  box-sizing: border-box;\n  width: 100%;\n  text-align: center;\n\n  p{\n    strong{\n      color: $Orange;\n    }\n  }\n}\n\n// Signup Verification Popup Styles\n.signup-verification-popup {\n  .verification-popup-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n    width: 100%;\n  }\n\n  .verification-message {\n    font-size: 16px;\n    line-height: 1.5;\n    color: $G_08;\n    text-align: center;\n    margin: 0;\n\n    strong {\n      color: $Orange;\n      font-weight: 600;\n    }\n  }\n\n  .countdown-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    padding: 16px 16px 24px;\n    background-color: $G_01;\n    border-radius: 12px;\n    width: 100%;\n  }\n\n  .countdown-timer {\n    font-size: 32px;\n    color: $Orange;\n    letter-spacing: 2px;\n  }\n\n  .countdown-text {\n    font-size: 16px;\n    color: $G_08;\n    text-align: center;\n    margin: 0;\n  }\n}\n\n// - - - - - - - - - - - PHOTO UPLOADER - - - - - - - - - - -\n\n.photo-uploader-circle {\n  border-radius: 50%;\n  background-color: $G_01;\n  border: 2px dashed $G_04;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.3s ease;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    left: -100px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 8px;\n    width: 80px;\n    background-color: $G_03;\n    border-radius: 0px;\n    z-index: -1;\n  }\n\n  &.drag-active {\n    border-color: $Blue;\n    box-shadow: 0 0 0 4px rgba($Blue, 0.2);\n  }\n\n  &.has-image {\n    border-color: $G_03;\n  }\n\n  .photo-placeholder-circle {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    color: $G_06;\n    position: relative;\n\n    svg {\n      width: 44px;\n      height: 44px;\n      stroke-width: 1px;\n      color: $G_06;\n      transition: all 0.2s ease;\n    }\n\n    .upload-text {\n      font-size: 12px;\n      color: $G_07;\n      margin-top: 8px;\n    }\n  }\n\n  .uploaded-image-circle {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &:hover {\n    background-color: rgba($Dark, 0.3);\n\n    .upload-text {\n      color: $White;\n    }\n\n    svg {\n      stroke-width: 1.2px;\n      color: $White;\n      scale: 1.1;\n      transition: all 0.2s ease;\n    }\n  }\n\n  .image-overlay-circle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: $White;\n    gap: 8px;\n    background-color: rgba($Dark, 0.4);\n\n    .delete-photo-btn, .change-photo-btn {\n      background-color: rgba($Dark, 0.7);\n      color: $White;\n      border: none;\n      border-radius: 44px;\n      --avatar-size: 40px;\n      width: var(--avatar-size);\n      height: var(--avatar-size);\n      min-width: var(--avatar-size);\n      min-height: var(--avatar-size);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      svg {\n    --avatar-size: 24px;\n    width: var(--avatar-size);\n    height: var(--avatar-size);\n    min-width: var(--avatar-size);\n    min-height: var(--avatar-size);\n        stroke-width: 1.2px;\n      }\n\n      &:hover {\n        background-color: $Red;\n        transform: scale(1.1);\n      }\n    }\n           .delete-photo-btn{background-color: $Red;}\n       .change-photo-btn {background-color: $Green;}\n\n\n    .change-photo-btn {\n      &:hover {\n        background-color: $Green;\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  &:hover .image-overlay-circle {\n    opacity: 1;\n  }\n\n}\n\n// Cropper styles for use with Popup component\n.cropper-area {\n  position: relative;\n  width: 280px;\n  height: 280px;\n  border-radius: 300px;\n  overflow: hidden;\n  background-color: $G_01;\n  transition: all 0.2s ease;\n\n  .reactEasyCrop_Container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  @media screen and (max-width: 460px) {\n    width: 200px;\n    height: 200px;\n    transition: all 0.2s ease;\n  }\n\n}\n\n.cropper-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n\n  .zoom-control {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    span {\n      color: $G_07;\n      font-size: 14px;\n      min-width: 40px;\n    }\n\n    input[type=\"range\"] {\n      flex: 1;\n      height: 8px;\n      -webkit-appearance: none;\n      appearance: none;\n      background: linear-gradient(to right, $G_03 0%, $G_03 100%);\n      border-radius: 12px;\n      outline: none;\n      position: relative;\n      \n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: $G_01;\n        border-radius: 12px;\n        z-index: -1;\n      }\n\n      /* Webkit (Chrome, Safari, Edge) */\n      &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        appearance: none;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: $Orange;\n        border: 2px solid $Orange;\n        cursor: pointer;\n      }\n      \n      /* Firefox */\n      &::-moz-range-thumb {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: $Orange;\n        border: 2px solid $Orange;\n        cursor: pointer;\n      }\n      \n      /* IE */\n      &::-ms-thumb {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        background-color: $Orange;\n        border: 2px solid $Orange;\n        cursor: pointer;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n    }\n  }\n\n  .cropper-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    width: 120px;\n  }\n  \n}\n\n.cropper-popup .popup-container{\n  width: 80%;\n  max-width: 400px\n}\n\n// - - - - - - - - - - - - - - AlERT - - - - - - - - - - - - - -\n.alert-container {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: 88%;\n  max-width: 400px;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  // border: 2px solid black;\n  \n  &.alert-entering {\n    animation: slideDown 0.3s forwards;\n  }\n\n  // Errors should appear immediately (no slide-in delay)\n  &.alert-enter-instant {\n    animation: none;\n  }\n  \n  &.alert-leaving {\n    animation: slideUp 0.3s forwards;\n  }\n\n  @media screen and (max-width: 760px) {\n    top: 10px;\n  }\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 12px;\n  padding: 12px 20px 12px 12px;\n  display: flex;\n  align-items: center;\n  min-width: 200px;\n  pointer-events: auto;\n  \n  .alert-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    svg {\n      width: 26px;\n      height: 26px;\n      color: $White;\n    }\n  }\n  \n  .alert-message {\n    flex: 1;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1;\n    color: $White;\n  }\n  \n  .alert-close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    svg {\n      width: 24px;\n      height: 24px;\n      opacity: 0.6;\n      color: $White;\n      transition: opacity 0.2s ease;\n      stroke-width: 2px;\n    }\n    \n    &:hover svg {\n      opacity: 1;\n      scale: 1.1;\n    }\n  }\n  \n  &.alert-success {\n    background-color: $Green;\n  }\n  \n  &.alert-error {\n    background-color: $Red;\n  }\n  \n  &.alert-warning {\n    background-color: $Orange;\n  }\n  \n  &.alert-info {\n    background-color: $Blue;\n  }\n  \n  &.alert-loading {\n    // background-color: rgba($Dark, 0.2);\n    border: 2px solid $Dark;\n    .alert-message {\n    color: $Dark;\n    }\n    svg {\n      color: $Dark;\n    }\n  }\n\n    @media screen and (max-width: 760px) {\n     padding: 10px 18px 10px 10px;\n\n     .alert-message {\n      font-size: 15px;\n    }\n  }\n}\n\n/* Alert test buttons styling */\n.alert-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-80px) translateX(-50%);\n    transition: transform 0.3s ease;\n  }\n  to {\n    transform: translateY(0) translateX(-50%);\n    transition: transform 0.3s ease;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(0) translateX(-50%);\n    transition: transform 0.3s ease;\n  }\n  to {\n    transform: translateY(-80px) translateX(-50%);\n    transition: transform 0.3s ease;\n  }\n}\n\n// - - - - - - - - - - - MenuDropdown - - - - - - - - - -\n.menu-dropdown {\n  position: relative;\n  display: inline-block;\n\n  // .menu-trigger {\n  //   cursor: pointer;\n\n  //   @media screen and (max-width: 768px) {\n  //     width: 40px;\n  //   }\n  // }\n\n  .menu-panel {\n    position: absolute;\n    top: calc(100% + 4px);\n    min-width: 148px;\n    background-color: $White;\n    border-radius: 12px;\n    box-shadow: 0 1px 1px rgba(0,0,0,0.1);\n    padding: 0;\n    z-index: 1000;\n    border: 2px solid $G_01;\n    overflow: hidden;\n    will-change: transform, opacity;\n    transform: translateZ(0);\n    backface-visibility: hidden;\n\n    &.align-right { \n      right: 0;\n    }\n  }\n\n    .footer-menu {\n           bottom: 100% !important;\n        top: auto !important;\n        margin-bottom: 8px;\n        min-width: 168px !important;\n    }\n\n  .menu-items {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    padding: 10px 0;\n          \n    .menu-item {\n      a {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 6px;\n        padding: 5px 8px;\n        color: $Dark;\n        text-decoration: none;\n      }\n\n     svg, .icon svg {\n        width: 24px;\n        height: 24px;\n        color: $G_06;\n      }\n\n      &:hover a {\n        background-color: $G_01;\n      }\n\n      &.disabled a {\n        color: $G_06;\n        pointer-events: none;\n      }\n    }\n    @media screen and (max-width: 768px) {\n    .menu-item {\n      a {\n        padding: 8px;\n      }\n     svg, .icon svg {\n        width: 26px;\n        height: 26px;\n      }\n    }\n\n    }\n  }\n\n//   @media screen and (max-width: 768px) {\n//     padding: 0;\n    \n//     .menu{\n//     .svg-icon{\n//       min-width: 28px;\n//       min-height: 28px;\n//       display: block;\n//       stroke-width: 2px;\n//     }\n//     span{\n//       display: none;\n//     }\n//   }\n// }\n}\n\n.menu {\n  padding: 0 8px;\n  gap: 0px;\n\n  .svg-icon {\n    display: none;\n    stroke-width: 1.6px;\n  }\n\n  @media screen and (max-width: 400px) {\n    padding: 0 6px;\n\n     .svg-icon {\n    display: block;\n  }\n\n  span{\n    display: none;\n  }\n  }\n\n}\n\n// Reusable small count badge, used in menus and titles\n.count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  // padding: 0 6px;\n  margin-left: 8px;\n  // border-radius: 9px;\n  font-size: 32px;\n  line-height: 1;\n  font-weight: 4\n  00;\n  color: $Dark;\n  // background: #ff4d4f;\n}\n\n.label {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 08px;\n  // background-color: $G_02;\n  width: 100%;\n  flex: 1;\n  width: 100%;\n  // padding-right: 16px;\n\nspan {\n  font-size: 18px;\n  // margin-left: 24px;\n  color: $Orange;\n}\n\n}\n\n\n// - - - - - - - - FAVS PAGE - - - - - - - - -\n// Utilities for Favs.jsx inline styles\n.muted-text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: $G_06;\n  font-size: 28px;\n  padding: 48px 0;\n  height: 100%;\n  width: 100%;\n  margin-bottom: 100px;\n  // background-color: #fecaca;\n  flex: 1;\n\n  svg{\n    width: 110px;\n    height: auto;\n    stroke-width: 2px;\n    transition: all 0.2s ease;\n    color: $G_06;\n    padding: 0;\n  }\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n.column-center-gap-8 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n\n// - - - - - - ResponsiveImage - - - - - - - - - -\n\n  .responsive-image-container {\n    width: 100%;\n    position: relative;\n\n\n  .responsive-image {\n    width: 100%;\n    border-radius: 20px;\n    object-fit: cover;\n    \n    &.desktop-image {\n      display: block;\n    }\n    \n    &.mobile-image {\n      display: none;\n    }\n    \n    @media screen and (max-width: 600px) {\n      &.desktop-image {\n        display: none;\n      }\n      \n      &.mobile-image {\n        display: block;\n      }\n    }\n  }\n}\n\n// - - - - - - - - - - - COUNTDOWN TIMER STYLES - - - - - - - - - - \n.countdown-container {\n  \n\n  \n  .countdown-timer {\n    .countdown-time {\n      font-size: 2rem;\n      font-weight: 700;\n      color: $Dark;\n      font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n  }\n  \n}\n\n// - - - - - - - - - - - CONFIRM VERIFICATION PAGE - - - - - - - - - - \n.confirm-verification {\n  &__container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: $G_00;\n    padding: 2rem 1rem;\n  }\n\n  &__wrapper {\n    max-width: 480px;\n    width: 100%;\n  }\n\n  &__card {\n    background: $White;\n    border-radius: 16px;\n    box-shadow: 0 4px 20px rgba(38, 17, 71, 0.08);\n    border: 1px solid $G_04;\n    overflow: hidden;\n  }\n\n  &__header {\n    padding: 2rem;\n    text-align: center;\n    border-bottom: 1px solid $G_04;\n  }\n\n  &__icon-container {\n    margin: 0 auto 1.5rem;\n    height: 4rem;\n    width: 4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    \n    &--verifying {\n      background-color: $G_02;\n    }\n    \n    &--success {\n      background-color: rgba($Green, 0.1);\n    }\n    \n    &--error {\n      background-color: rgba($Red, 0.1);\n    }\n  }\n\n  &__spinner {\n    animation: spin 1s linear infinite;\n    border-radius: 50%;\n    height: 2rem;\n    width: 2rem;\n    border: 3px solid $G_05;\n    border-top-color: $Dark;\n  }\n\n  &__status-icon {\n    height: 2rem;\n    width: 2rem;\n    \n    &--success {\n      color: $Green;\n    }\n\n    &--error {\n      color: $Red;\n    }\n  }\n\n  &__title {\n    font-size: 24px;\n    font-weight: 600;\n    color: $Dark;\n    margin-bottom: 0.5rem;\n  }\n\n  &__subtitle {\n    color: $Text;\n    font-size: 16px;\n    line-height: 1.4;\n  }\n\n  &__content {\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  &__message {\n    padding: 1rem;\n    border-radius: 10px;\n    font-size: 16px;\n    line-height: 1.4;\n\n    &--success {\n      background-color: rgba($Green, 0.1);\n      color: $Dark;\n      border: 1px solid rgba($Green, 0.2);\n    }\n\n    &--error {\n      background-color: rgba($Red, 0.1);\n      color: $Dark;\n      border: 1px solid rgba($Red, 0.2);\n    }\n\n    &--info {\n      background-color: $G_02;\n      color: $Text;\n      border: 1px solid $G_04;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  &__button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n    height: 52px;\n    padding: 0 1rem;\n    border-radius: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    text-decoration: none;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n\n    &--primary {\n      background-color: $Dark;\n      color: $White;\n      border: 2px solid $Dark;\n\n      &:hover {\n        background-color: $Orange;\n        border-color: $Orange;\n      }\n    }\n\n    &--secondary {\n      background-color: transparent;\n      color: $Dark;\n      border: 2px solid $Dark;\n\n      &:hover {\n        background-color: $Dark;\n        color: $White;\n      }\n    }\n\n    &--outline {\n      background-color: transparent;\n      color: $Orange;\n      border: 2px solid $Orange;\n\n      &:hover {\n        background-color: $Orange;\n        color: $White;\n      }\n    }\n  }\n\n  &__loading {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  &__dots {\n    display: flex;\n    justify-content: center;\n    gap: 0.25rem;\n\n    .dot {\n      height: 0.5rem;\n      width: 0.5rem;\n      background-color: $Dark;\n      border-radius: 50%;\n      animation: bounce 1.4s ease-in-out infinite both;\n\n      &:nth-child(1) { animation-delay: -0.32s; }\n      &:nth-child(2) { animation-delay: -0.16s; }\n      &:nth-child(3) { animation-delay: 0s; }\n    }\n  }\n\n  &__footer {\n    text-align: center;\n    margin-top: 1.5rem;\n    color: $G_08;\n    font-size: 14px;\n  }\n\n  &__support-link {\n    color: $Orange;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &__helper-text {\n    text-align: center;\n    color: $G_08;\n    font-size: 14px;\n    margin-top: 0.5rem;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
